var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "3167.564 233.237 879.496 593.236",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath418"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,2890 H 5000 V 0 H 0 Z",
    id: "path416"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333332538604736, 0, 0, -1.3333332538604736, 0, 3853.333251953125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g414",
    clipPath: "url(#clipPath418)",
    transform: "translate(1139.5674,453.68356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g420",
    transform: "translate(796.29,1659.0157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 69.294 H 19.798 V 0 c 0,-9.523 -2.852,-16.97 -8.555,-22.344 -5.705,-5.374 -13.081,-8.061 -22.132,-8.061 -9.051,0 -16.453,2.687 -22.202,8.061 -5.752,5.374 -8.627,12.821 -8.627,22.344 h 19.94 c 0.092,-4.055 1.083,-7.19 2.97,-9.404 1.885,-2.216 4.525,-3.324 7.919,-3.324 3.394,0 6.056,1.108 7.99,3.324 C -0.968,-7.19 0,-4.055 0,0",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path422"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g424",
    transform: "translate(916.917,1655.6925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 5.562,5.891 8.343,13.74 8.343,23.546 0,9.804 -2.781,17.628 -8.343,23.475 -5.564,5.845 -12.822,8.768 -21.778,8.768 -8.958,0 -16.241,-2.948 -21.849,-8.839 -5.61,-5.893 -8.415,-13.717 -8.415,-23.475 0,-9.758 2.805,-17.584 8.415,-23.475 5.608,-5.893 12.891,-8.838 21.849,-8.838 8.956,0 16.214,2.945 21.778,8.838 m -21.778,-27.082 c -14.237,0 -26.211,4.76 -35.92,14.284 -9.711,9.521 -14.566,21.612 -14.566,36.273 0,14.659 4.879,26.75 14.637,36.274 9.757,9.521 21.73,14.283 35.919,14.283 14.189,0 26.138,-4.762 35.85,-14.283 9.709,-9.524 14.566,-21.615 14.566,-36.274 0,-14.661 -4.857,-26.752 -14.566,-36.273 -9.712,-9.524 -21.685,-14.284 -35.92,-14.284",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path426"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g428",
    transform: "translate(1034.4331,1728.5929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 19.939 V -98.992 H 0 l -44.688,68.446 V -98.992 H -64.627 V 0 h 19.939 L 0,-68.446 Z",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path430"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g432",
    transform: "translate(1109.2407,1663.3995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 28.142 L 14,41.152 Z m 39.597,-33.798 -6.364,18.525 H -5.232 l -6.364,-18.525 h -21.071 l 34.93,98.991 h 23.616 l 34.788,-98.991 z",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path434"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g436",
    transform: "translate(1186.4521,1713.0367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 15.273 H 73.112 V 0 H 46.385 V -83.436 H 26.586 V 0 Z",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path438"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g440",
    transform: "translate(1345.6875,1728.3102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 19.94 V -98.709 H 0 v 42.284 h -42.425 v -42.284 h -19.94 V 0 h 19.94 V -41.152 H 0 Z",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g444",
    transform: "translate(1420.4961,1663.3995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 28.142 L 14,41.152 Z m 39.597,-33.798 -6.364,18.525 H -5.232 l -6.364,-18.525 h -21.071 l 34.93,98.991 h 23.616 l 34.788,-98.991 z",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path446"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g448",
    transform: "translate(1568.1333,1728.5929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 19.939 V -98.992 H 0 l -44.688,68.446 V -98.992 H -64.627 V 0 h 19.939 L 0,-68.446 Z",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path450"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g452",
    transform: "translate(1679.8481,1640.7731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 48.082 V -11.172 H -15.272 V -0.99 L 32.526,76.224 H -14.707 V 87.396 H 47.799 V 77.213 Z",
    style: {
      fill: "#063d54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path454"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g456",
    transform: "translate(1808.5356,1661.9855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -17.818,49.779 -35.637,0 Z m 3.677,-10.465 h -42.991 l -7.919,-21.919 h -13.576 l 35.637,98.002 h 14.849 L 25.172,-32.384 H 11.596 Z",
    style: {
      fill: "#063d54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g460",
    transform: "translate(1939.2041,1728.1686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -37.193,-98.567 H -52.042 L -89.234,0 h 13.717 L -44.546,-84.991 -13.576,0 Z",
    style: {
      fill: "#063d54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path462"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 1974.699,1629.601 h -12.869 v 98.567 h 12.869 z",
    style: {
      fill: "#063d54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path464"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g466",
    transform: "translate(2059.689,1661.9855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -17.818,49.779 -35.637,0 Z m 3.677,-10.465 h -42.991 l -7.919,-21.919 H -60.81 l 35.638,98.002 h 14.848 L 25.172,-32.384 H 11.596 Z",
    style: {
      fill: "#063d54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g470",
    transform: "translate(2121.77,1640.066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 34.505 V -10.465 H -12.869 V 88.103 H 0 Z",
    style: {
      fill: "#063d54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path472"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g474",
    transform: "translate(2241.7612,1644.5914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 5.515,3.204 9.851,7.778 13.01,13.717 3.157,5.94 4.738,12.821 4.738,20.647 0,7.92 -1.581,14.824 -4.738,20.718 -3.159,5.891 -7.473,10.44 -12.94,13.647 -5.468,3.203 -11.691,4.808 -18.667,4.808 -6.978,0 -13.2,-1.605 -18.667,-4.808 -5.468,-3.207 -9.782,-7.756 -12.939,-13.647 -3.16,-5.894 -4.737,-12.798 -4.737,-20.718 0,-7.826 1.577,-14.707 4.737,-20.647 3.157,-5.939 7.495,-10.513 13.01,-13.717 5.515,-3.206 11.714,-4.808 18.596,-4.808 6.881,0 13.081,1.602 18.597,4.808 m -43.627,-9.546 c -7.544,4.289 -13.505,10.275 -17.89,17.96 -4.383,7.683 -6.576,16.334 -6.576,25.95 0,9.616 2.193,18.265 6.576,25.95 4.385,7.683 10.346,13.669 17.89,17.96 7.542,4.289 15.884,6.434 25.03,6.434 9.239,0 17.629,-2.145 25.173,-6.434 7.541,-4.291 13.481,-10.253 17.818,-17.889 4.335,-7.636 6.505,-16.312 6.505,-26.021 0,-9.711 -2.17,-18.384 -6.505,-26.02 C 20.057,0.707 14.117,-5.257 6.576,-9.546 c -7.544,-4.291 -15.934,-6.434 -25.173,-6.434 -9.146,0 -17.488,2.143 -25.03,6.434",
    style: {
      fill: "#063d54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path476"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g478",
    transform: "translate(2379.5708,1728.1686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -37.193,-98.567 H -52.042 L -89.234,0 h 13.717 L -44.546,-84.991 -13.576,0 Z",
    style: {
      fill: "#063d54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path480"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g482",
    transform: "translate(1601.4995,2032.1276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.959,0 -7.179,3.22 -7.179,7.18 0,3.952 3.22,7.173 7.179,7.173 3.953,0 7.173,-3.221 7.173,-7.173 C 7.173,3.22 3.953,0 0,0 m 0,26.906 c -8.682,0 -16.058,-5.645 -18.69,-13.45 h -33.922 l -42.567,-36.838 h -63.348 v -12.56 h 67.326 l 42.573,36.838 h 29.938 c 3.018,-8.959 12.294,-15.072 22.618,-13.07 7.691,1.496 13.898,7.684 15.407,15.369 C 21.816,15.812 12.181,26.906 0,26.906",
    style: {
      fill: "#063d54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path484"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g486",
    transform: "translate(1567.0713,1933.5948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 28.281 h -95.3 c -14.53,0 -26.308,11.779 -26.308,26.309 v 151.279 c 0,10.522 8.529,19.051 19.05,19.051 h 62.899 v 102.871 h -261.18 c 0,-28.402 11.513,-54.123 30.13,-72.741 18.617,-18.617 44.331,-30.13 72.74,-30.13 h 57.85 V 37.846 c 0,-21.754 -5.013,-38.067 -15.033,-48.947 -10.027,-10.873 -22.073,-16.313 -36.154,-16.313 -29.433,0 -57.579,14.493 -84.452,43.506 l -51.826,-71.659 c 40.085,-41.38 87.012,-62.059 140.759,-62.059 43.079,0 78.379,13.212 105.892,39.666 12.765,12.273 22.536,27.47 29.377,45.533 H -90.12 V 0 Z",
    style: {
      fill: "#063d54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path488"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g490",
    transform: "translate(1618.6157,2092.092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.953,0 -7.173,3.22 -7.173,7.173 0,3.959 3.22,7.173 7.173,7.173 3.959,0 7.18,-3.214 7.18,-7.173 C 7.18,3.22 3.959,0 0,0 m 0,26.906 c -8.683,0 -16.058,-5.646 -18.685,-13.456 h -61.633 l -39.819,22.062 h -57.588 V 22.959 h 54.343 L -83.564,0.896 h 64.879 c 3.019,-8.966 12.301,-15.085 22.631,-13.07 7.685,1.503 13.886,7.691 15.395,15.375 C 21.816,15.811 12.181,26.906 0,26.906",
    style: {
      fill: "#063d54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path492"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g494",
    transform: "translate(1515.584,2054.0398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.953,0 -7.173,3.214 -7.173,7.173 0,3.959 3.22,7.174 7.173,7.174 3.959,0 7.179,-3.215 7.179,-7.174 C 7.179,3.214 3.959,0 0,0 m 0,26.906 c -8.683,0 -16.058,-5.645 -18.685,-13.456 H -70.633 V 0.897 h 51.948 c 3.018,-8.967 12.301,-15.086 22.631,-13.071 7.685,1.502 13.886,7.691 15.395,15.376 C 21.816,15.812 12.18,26.906 0,26.906",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g498",
    transform: "translate(1894.6567,1815.965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,48.058 -38.958,85.2 -87.017,85.2 h -122.078 l 0.001,10e-4 H -346.02 V 0 Z",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g502",
    transform: "translate(1756.5469,2139.4661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -137.62 L 134.271,52.821 v 69.102 H -200.232 V 19.051 H -19.05 C -8.529,19.051 0,10.521 0,0",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g506",
    transform: "translate(1728.3677,1961.8761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -19.94,-28.281 H -97.708 V 0 Z",
    style: {
      fill: "#03b0c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path508"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2f3e79be84eb902600c1fd276e213763.svg";
export { ForwardRef as ReactComponent };